import { render, staticRenderFns } from "./TeamOverview.vue?vue&type=template&id=81c6cc0c&scoped=true&"
import script from "./TeamOverview.vue?vue&type=script&lang=js&"
export * from "./TeamOverview.vue?vue&type=script&lang=js&"
import style0 from "./TeamOverview.vue?vue&type=style&index=0&id=81c6cc0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c6cc0c",
  null
  
)

export default component.exports